import React from 'react';
import './Profile.css';
import ProfileView from '../../components/ProfileView/ProfileView';
import BackButton from "../../components/BackButton/BackButton";


export default function Profile() {
    return (<>
        <BackButton/>
        <>
            <ProfileView/>
        </>
    </>);
}